/* ══════════════════════════════════════════════════════════════
   MIRAVELLO — Kaufmeldung, Ablauf

   Gehoert zu snippets/mv-kaufmeldung.liquid (Markup + Pflegestelle) und
   assets/mv-kaufmeldung.css (Aussehen).

   HIER STEHEN KEINE NAMEN, KEINE ORTE, KEINE PRODUKTE UND KEINE ZEITEN.
   Alles davon kommt aus dem Snippet und steckt in <script
   type="application/json" id="mvkmDaten">. Das ist Absicht: Die Produktnamen
   werden dort in Liquid aus all_products geholt und sind damit immer die
   echten Titel aus dem Laden. Frueher standen sie im JavaScript — nach der
   Umbenennung vom 30.08.2026 stand dort monatelang „1 Beutel", waehrend das
   Produkt im Laden „Waschtasche" hiess. Das kann so nicht wieder passieren.
   ══════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  /* Zweimal eingebunden waere zweimal derselbe Zeitgeber auf derselben Karte.
     Der Riegel kostet nichts und schliesst es aus. */
  if (window.MV_KAUFMELDUNG) return;
  window.MV_KAUFMELDUNG = true;

  var doc = document;
  var karte = doc.getElementById("mvkmKarte");
  var datenEl = doc.getElementById("mvkmDaten");
  var titelEl = doc.getElementById("mvkmTitel");
  var metaEl = doc.getElementById("mvkmMeta");
  var bildEl = doc.getElementById("mvkmBild");
  var zuBtn = doc.getElementById("mvkmZu");

  /* JEDES Element einzeln pruefen, nicht nur die Karte. Im Vorbild auf der
     Landingpage war nur #pop abgesichert; fehlte der Schliessknopf, warf die
     naechste Zeile einen Fehler und riss den Rest der Datei mit. */
  if (!karte || !datenEl || !titelEl || !metaEl || !bildEl || !zuBtn) return;

  var K;
  try {
    K = JSON.parse(datenEl.textContent);
  } catch (e) {
    return;
  }
  if (!K || !K.namen || !K.namen.length || !K.orte || !K.orte.length ||
      !K.produkte || !K.produkte.length) return;

  /* ---------- Abschalten fuer diesen Besuch ----------
     sessionStorage, nicht eine blosse Variable: Wer die Meldung wegklickt,
     will sie nicht sehen — auch nicht auf der naechsten Seite. Beim naechsten
     Besuch (neuer Tab, neue Sitzung) faengt es wieder an.
     In Kastenmodus und privaten Fenstern wirft schon der Zugriff, deshalb
     jeder Zugriff in try/catch. */
  var SCHLUESSEL = "mv_kaufmeldung_aus";

  function istAus() {
    try { return sessionStorage.getItem(SCHLUESSEL) === "1"; } catch (e) { return false; }
  }
  function merkeAus() {
    try { sessionStorage.setItem(SCHLUESSEL, "1"); } catch (e) { /* egal */ }
  }

  if (istAus()) return;

  /* ---------- Hilfsmittel ---------- */
  var zufall = function (a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; };

  function zahl(wert, ersatz) {
    var n = parseInt(wert, 10);
    return isFinite(n) ? n : ersatz;
  }

  var startMs = Math.max(500, zahl(K.start, 6000));
  var dauerMs = Math.max(2000, zahl(K.dauer, 7000));
  var pauseVon = Math.max(1000, zahl(K.pause && K.pause[0], 18000));
  var pauseBis = Math.max(pauseVon, zahl(K.pause && K.pause[1], 38000));
  var alterVon = Math.max(1, zahl(K.alter && K.alter[0], 2));
  var alterBis = Math.max(alterVon + 1, zahl(K.alter && K.alter[1], 24));

  /* Gewichtung: jedes Produkt bekommt so viele Lose, wie im Snippet hinter
     dem Sternchen steht. Die Waschtasche kommt damit oefter vor als das
     Schaumreiniger-Set — so, wie es sich auch verkauft. */
  var lose = [];
  for (var i = 0; i < K.produkte.length; i++) {
    var p = K.produkte[i];
    if (!p || !p.t) continue;
    var g = Math.max(1, Math.min(20, zahl(p.g, 1)));
    for (var k = 0; k < g; k++) lose.push(i);
  }
  if (!lose.length) return;

  /* ---------- Abstand nach unten ----------
     Klebt ein Kaufbalken am unteren Rand, muss die Karte darueber sitzen —
     verdeckt sie den Kaufknopf, kostet sie Geld statt welches zu bringen.
     Gemessen wird zur Laufzeit statt fest eingetragen: Die Landingpage hat
     .buybar (z-index 700), die Produktseite .kaufbar (z-index 60, andere
     Hoehe), der Warenkorb gar keinen — und beide Balken fahren beim Scrollen
     ein und aus. Eine feste Zahl waere auf drei von vier Seiten falsch. */
  function balkenHoehe() {
    var kandidaten = doc.querySelectorAll(".kaufbar, .buybar");
    var hoehe = 0;
    for (var n = 0; n < kandidaten.length; n++) {
      var el = kandidaten[n];
      var st = window.getComputedStyle(el);
      if (st.position !== "fixed" || st.display === "none" || st.visibility === "hidden") continue;
      var r = el.getBoundingClientRect();
      if (r.height <= 0) continue;
      /* Nach unten weggeschoben (transform: translateY(105%)) — zaehlt nicht. */
      if (r.top >= window.innerHeight - 4) continue;
      /* Klebt nicht wirklich an der Unterkante — zaehlt auch nicht. */
      if (r.bottom < window.innerHeight - 8) continue;
      if (r.height > hoehe) hoehe = r.height;
    }
    return hoehe;
  }

  function setzeBoden() {
    var h = balkenHoehe();
    /* Der Balken bringt seine eigene Sicherheitszone (env(safe-area-inset-bottom))
       schon mit — deshalb hier KEIN --safe-b obendrauf, das waere doppelt. */
    if (h > 0) karte.style.setProperty("--mvkm-boden", Math.round(h + 14) + "px");
    else karte.style.removeProperty("--mvkm-boden");
  }

  var bodenLaeuft = false;
  function bodenNachfuehren() {
    if (bodenLaeuft) return;
    bodenLaeuft = true;
    window.requestAnimationFrame(function () {
      bodenLaeuft = false;
      if (karte.classList.contains("is-an")) setzeBoden();
    });
  }
  window.addEventListener("scroll", bodenNachfuehren, { passive: true });
  window.addEventListener("resize", bodenNachfuehren, { passive: true });

  /* ---------- Eine Meldung zusammenstellen ----------
     Nicht zweimal hintereinander derselbe Name, derselbe Ort oder dasselbe
     Produkt. Die Obergrenze an Versuchen verhindert eine Endlosschleife,
     wenn jemand die Listen auf einen einzigen Eintrag kuerzt. */
  var letzterName = "";
  var letzterOrt = "";
  var letztesProdukt = -1;
  var alter = zufall(alterVon, Math.min(alterBis, alterVon + 8));

  function naechstesAlter() {
    /* Wandert langsam, statt frei zu wuerfeln. Frei gewuerfelt folgte auf
       „vor 39 Minuten" schon mal „vor 2 Minuten" — wer laenger als eine
       Minute zusieht, merkt das. */
    alter = alter + zufall(-4, 7);
    if (alter < alterVon) alter = alterVon + zufall(0, 2);
    if (alter > alterBis) alter = alterBis - zufall(0, 4);
    if (alter < 1) alter = 1;
    return alter;
  }

  function baue() {
    var name, ort, pi, versuche = 0;
    do {
      name = K.namen[zufall(0, K.namen.length - 1)];
      ort = K.orte[zufall(0, K.orte.length - 1)];
      pi = lose[zufall(0, lose.length - 1)];
      versuche++;
    } while (versuche < 12 &&
             (name === letzterName || ort === letzterOrt || pi === letztesProdukt));

    letzterName = name;
    letzterOrt = ort;
    letztesProdukt = pi;

    var m = naechstesAlter();
    return {
      name: name,
      ort: ort,
      produkt: K.produkte[pi],
      zeit: m === 1 ? "vor 1 Minute" : "vor " + m + " Minuten"
    };
  }

  /* ---------- Zeigen und verbergen ----------
     Genau EINE Kette aus zwei Zeitgebern, beide gemerkt und vor jedem
     Neustart geloescht. Zwei Meldungen koennen sich so nicht ueberholen. */
  var uhrAus = null;
  var uhrAn = null;
  var beendet = false;

  function verbergen() {
    karte.classList.remove("is-an");
  }

  function planen(ms) {
    if (beendet) return;
    window.clearTimeout(uhrAn);
    uhrAn = window.setTimeout(zeigen, ms);
  }

  function zeigen() {
    if (beendet || istAus()) return;

    /* Liegt der Tab im Hintergrund, wird die Meldung nicht verbraucht —
       sie wird nachgeholt, sobald jemand wieder hinsieht. */
    if (doc.hidden) {
      planen(4000);
      return;
    }

    var d = baue();
    titelEl.textContent = d.name + " aus " + d.ort;
    metaEl.textContent = "hat bestellt: " + d.produkt.t + " · " + d.zeit;

    if (d.produkt.b) {
      bildEl.src = d.produkt.b;
      bildEl.hidden = false;
    } else {
      bildEl.hidden = true;
    }

    setzeBoden();
    karte.classList.add("is-an");

    window.clearTimeout(uhrAus);
    uhrAus = window.setTimeout(verbergen, dauerMs);
    planen(dauerMs + zufall(pauseVon, pauseBis));
  }

  zuBtn.addEventListener("click", function () {
    beendet = true;
    window.clearTimeout(uhrAn);
    window.clearTimeout(uhrAus);
    merkeAus();
    verbergen();
  });

  planen(startMs);
})();
